/** Shared river centerline math — world-fixed Z band with sine warp along X. */

export const RIVER_Z = 13.8;
export const RIVER_AMP = 2.0;
export const RIVER_FREQ = 0.18;
export const RIVER_HALF_W = 1.7;
export const RIVER_MARGIN = 1.1;
export const RIVER_WIDTH = RIVER_HALF_W * 2;

export function riverCenterZ(x: number): number {
  return RIVER_Z + Math.sin(x * RIVER_FREQ) * RIVER_AMP;
}

export function isInRiver(x: number, z: number, radius = 0): boolean {
  return Math.abs(z - riverCenterZ(x)) < RIVER_HALF_W + RIVER_MARGIN + radius;
}
